
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BillingUI2ProductSection',
  props: {
    product: {
      type: String,
      default: ''
    }
  }
})
